import { SET_GRAPH_TICKS } from './types';

const graphTicks = (state = null, action) => {
  switch (action.type) {
    case SET_GRAPH_TICKS:
      return action.graphTicks;
    default:
      return state;
  }
};

export default graphTicks;
